import React from "react";
import styled from "styled-components";

// components
import LoadingSpinner from "core/LoadingSpinner";
import { Div } from "core/LoadingSpinner/styles";

//styles
import { convertPxToRem } from "frontend/components/helpers";
const LoadingStyled = styled.div`
    height: ${convertPxToRem(129)};
    display: flex;
    justify-content: center;
    align-items: center;

    ${Div} {
        p {
            margin: 0;
            margin-right: 0.625rem;
        }
    }
`;

// component
const Loading = () => {
    return (
        <LoadingStyled>
            <LoadingSpinner />
        </LoadingStyled>
    );
};

export default Loading;
